export default __webpack_public_path__ + "static/EYInterstateBold-cfdc7f1a52448774f4520a6be09225c7.woff";